import { useTranslation } from "react-i18next";
import { Button } from "./Button";
import { cn } from "../../lib/utils";

export const CALENDLY_URL =
  "https://calendly.com/juisci-demo/share-your-insights-on-juisci";
const SUGGEST_IDEAS_URL = "https://juiscifeedbackportal.lovable.app/";

function FeedbackIllustration() {
  return (
    <svg
      className="shrink-0"
      width="105"
      height="105"
      viewBox="0 0 105 105"
      fill="none"
    >
      <path
        d="M32.6894 22.7417L44.7659 10.6652M32.6894 22.7417V13.0805M32.6894 22.7417H42.3506M8.53647 10.6652H18.1977L23.0282 22.7417L16.99 26.3646C19.5767 31.6095 23.8216 35.8544 29.0665 38.4411L32.6894 32.4029L44.7659 37.2335V46.8946C44.7659 48.1758 44.257 49.4045 43.351 50.3104C42.4451 51.2163 41.2165 51.7252 39.9353 51.7252C30.5139 51.1527 21.6277 47.1519 14.9535 40.4776C8.27925 33.8034 4.27843 24.9172 3.70588 15.4958C3.70588 14.2147 4.21482 12.986 5.12073 12.0801C6.02664 11.1742 7.25532 10.6652 8.53647 10.6652Z"
        stroke="#59D9BD"
        strokeWidth="2.64864"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48 78.5285H50.2809M68.5285 58V60.2809M86.7761 78.5285H89.0571M53.9305 63.9305L55.5271 65.5271M83.1266 63.9305L81.5299 65.5271M63.2822 89.9333H73.7746M61.6857 87.6523C59.7708 86.2161 58.3563 84.2138 57.6426 81.9291C56.9288 79.6443 56.9521 77.1929 57.709 74.922C58.466 72.6512 59.9182 70.6761 61.8601 69.2765C63.8019 67.8769 66.1349 67.1238 68.5285 67.1238C70.9222 67.1238 73.2552 67.8769 75.197 69.2765C77.1388 70.6761 78.5911 72.6512 79.348 74.922C80.105 77.1929 80.1282 79.6443 79.4145 81.9291C78.7008 84.2138 77.2863 86.2161 75.3714 87.6523C74.4808 88.5339 73.8103 89.6127 73.414 90.8014C73.0178 91.9902 72.9069 93.2556 73.0904 94.4952C73.0904 95.7051 72.6098 96.8654 71.7543 97.7209C70.8988 98.5764 69.7384 99.0571 68.5285 99.0571C67.3186 99.0571 66.1583 98.5764 65.3028 97.7209C64.4473 96.8654 63.9666 95.7051 63.9666 94.4952C64.1501 93.2556 64.0393 91.9902 63.643 90.8014C63.2468 89.6127 62.5762 88.5339 61.6857 87.6523Z"
        stroke="#135345"
        strokeWidth="3.27779"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FeedbackCard({ className }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <div className={cn("flex flex-col gap-4 rounded-2xl", className)}>
      <div className="flex items-center gap-6">
        <div className="flex flex-1 flex-col gap-1.5 text-ds-primary">
          <span className="block text-base font-bold leading-[1.3]">
            {t(
              "Join a 15-minute session to share feedback and explore opportunities."
            )}
          </span>
          <span className="block text-[13px] font-normal leading-[1.4]">
            {t("Free & quick. Your experience helps us build a better Juisci.")}
          </span>
        </div>
        <FeedbackIllustration />
      </div>

      <div className="flex gap-8">
        <a
          href={SUGGEST_IDEAS_URL}
          target="_blank"
          rel="noreferrer"
          className="flex-1"
        >
          <Button
            variant="outline"
            size="sm"
            className="h-9 w-full border-[rgba(11,17,16,0.46)] text-[13px] tracking-[-0.13px]"
          >
            {t("Suggest ideas")}
          </Button>
        </a>
        <a
          href={CALENDLY_URL}
          target="_blank"
          rel="noreferrer"
          className="flex-1"
        >
          <Button
            variant="secondary"
            size="sm"
            className="h-9 w-full text-[13px] tracking-[-0.13px]"
          >
            {t("Schedule a call")}
          </Button>
        </a>
      </div>
    </div>
  );
}
